import { useMemo } from 'react'

import { useLineChart } from './use-line-chart'

export const LineChartTickLines = () => {
  const { ticks, yScale, plotAreaWidth } = useLineChart()

  const ys = useMemo(() => {
    return ticks.map(yScale)
  }, [ticks, yScale])

  return (
    <g>
      {ys.map((y) => {
        return (
          <g key={y}>
            <path d={`M 0,${y} L ${plotAreaWidth},${y}`} className="stroke-border" strokeWidth={1} />
          </g>
        )
      })}
    </g>
  )
}
